{
  "$schema": "https://quantumetzchaim.com/schemas/build-contract-v0.3.schema.json",
  "id": "qec-build-0.3",
  "status": "executable-prototype",
  "updated": "2026-09-16",
  "packages": {
    "ivritCodeCore": {
      "name": "@ivritcode/core",
      "version": "1.0.0",
      "canonical": true
    },
    "qecCore": { "name": "@qec/core", "version": "0.1.0", "canonical": true },
    "qecSpec": { "name": "@qec/spec", "version": "0.1.0", "canonical": true }
  },
  "machine": {
    "radix": 22,
    "visibleRegisters": 22,
    "hiddenRegisters": 1,
    "stateSchema": "qec-machine-state-0.3",
    "traceSchema": "qec-trace-0.3"
  },
  "artifacts": {
    "pathMap": "qec-paths-v0.3.json",
    "gateRules": "qec-gate-rules-v0.1.json",
    "trace": "schemas/trace-v0.3.schema.json",
    "manifestation": "schemas/manifestation-v0.2.schema.json"
  },
  "determinism": {
    "canonicalSeed": 9,
    "seedType": "uint32",
    "wallClockInput": false,
    "systemRandomness": false,
    "canonicalJson": true,
    "classicalStateDependsOnCoherence": false
  },
  "limits": {
    "sourceGraphemes": 4096,
    "instructions": 1024,
    "executionSteps": 10000,
    "traceEvents": 50000,
    "exportBytes": 5242880,
    "recursion": 0
  },
  "invariants": [
    "register-count-is-23",
    "register-values-are-base-22",
    "state-and-events-are-immutable",
    "event-sequence-is-contiguous",
    "trace-hash-chain-is-continuous",
    "aleph-olam-does-not-flatten-visible-state",
    "unapproved-gate-directions-are-non-executable",
    "rendering-does-not-mutate-machine-state"
  ],
  "requiredSchemas": [
    "build-contract",
    "machine-state",
    "path-map",
    "gate-rules",
    "trace",
    "observation",
    "manifestation"
  ],
  "release": {
    "requiresAllGates": true,
    "allowsSkippedDeterminism": false,
    "allowsSkippedSecurity": false,
    "provenanceRequired": true
  },
  "verificationGates": [
    "schema",
    "typecheck",
    "unit",
    "property",
    "path-coverage",
    "gate-coverage",
    "golden-replay",
    "hash-chain",
    "coherence-separation",
    "security-corpus",
    "accessibility",
    "responsive"
  ],
  "disclaimer": "A deterministic symbolic software model; not physical quantum computation."
}
